import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import {
  dispatchHideOverlayEvent,
  dispatchShowOverlayEvent,
  useOutsideClick,
} from '../../../utils'

import FlyoutBody from './FlyoutBody'
import FlyoutHeader from './FlyoutHeader'

function FlyoutMenu({
  isVisible = false,
  hide,
  className,
  children,
  anchor = 'right',
}) {
  const ref = useRef(null)

  const wrapperClasses = classNames('flyout-menu', className, {
    [`flyout-menu--anchor-${anchor}`]: ['left', 'right'].includes(anchor),
    'flyout-menu--visible': isVisible,
  })

  useEffect(() => {
    if (isVisible) {
      dispatchShowOverlayEvent()
    }
    return () => {
      dispatchHideOverlayEvent()
    }
  }, [isVisible])

  useOutsideClick(ref, hide)

  return (
    <div ref={ref} className={wrapperClasses}>
      {children}
    </div>
  )
}

FlyoutMenu.propTypes = {
  isVisible: PropTypes.bool,
  hide: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.any,
  anchor: PropTypes.oneOf(['left', 'right']),
}

export default FlyoutMenu
export { FlyoutHeader, FlyoutBody }
